import { useState } from 'react';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import * as PropTypes from 'prop-types';

import Button from 'antd/lib/button';
import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';

import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';

import { container } from './InProgressImportButton.rules';

export const InProgressImportButton = ({ beginImport }) => {
    const { css } = useFela();

    const [visible, setVisibility] = useState(false);

    return (
        <div className={css(container)}>
            <Dropdown
                onVisibleChange={newVisibility => {
                    setVisibility(newVisibility);
                }}
                overlay={
                    <Menu>
                        <Menu.Item key="force">
                            <Button
                                type="primary"
                                danger
                                onClick={() => {
                                    setVisibility(false);
                                    beginImport();
                                }}
                            >
                                <FormattedMessage id="imports.button.force" />
                            </Button>
                        </Menu.Item>
                    </Menu>
                }
            >
                <Button loading={true} disabled={true} type="primary">
                    <FormattedMessage id="imports.button.submit" />
                    {visible ? (
                        <CaretUpOutlined width={20} height={20} />
                    ) : (
                        <CaretDownOutlined width={20} height={20} />
                    )}
                </Button>
            </Dropdown>
        </div>
    );
};

InProgressImportButton.propTypes = {
    beginImport: PropTypes.func.isRequired,
};
